import { formats } from "@/_shared/constants";

export const useTimepickers = {
  computed: {
    timepickerTypes() {
      return ['start', 'end'];
    },
  },
  methods: {
    getTitle(timetype) {
      const titles = {
        start: "Начало",
        end: "Конец",
      };
      return titles[timetype];
    },
    notAfterTenHoursPM(date) {
      return !!(date.getHours() >= 22);
    },
    getFormattedDate(value) {
      const date = new Date(value);
      return date.toLocaleString("ru", formats.dates.shiftsCalendar);
    },
  },
};



// WEBPACK FOOTER //
// ./src/user/mixins/shifts-calendar/useTimepickers.js